import React, { Fragment, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";

import { Tooltip } from "@revvsales/components";
import Table from "../RevvTable";
import { COMMON } from "../../constants";
import { getUngroupedData } from "../../utils/documentUtils";
import { numberForamting } from "../../utils/globalUtils";
import CustomQuoteTableWrapper from "./CustomQuoteTableWrapper";

// Actions Imports
import { QuotationActions } from "../../actions";
import ConfigureColumns from "./ConfigureColumns";
import {
  updateDocumentClickedComponentID,
  updateDraggedSection,
} from "../../actions/DocumentActions/index";

// Destructuring
const { updateToolPaneData, toggleTabView } = QuotationActions;
const { CURRENCY_SYMBOL, DEAL_LABELS } = COMMON;

// Decalarations
const QUOTE_TABLE = "QUOTE_TABLE";

class CustomQuoteTable extends Component {
  customQuoteTableRef = React.createRef();

  state = {
    showColumnSettings: false,
  };

  componentDidMount() {
    this.props.updateDraggedSection(null, null);
    if (
      this.customQuoteTableRef &&
      this.customQuoteTableRef.current &&
      this.props.isComponentActive
    ) {
      this.customQuoteTableRef.current.focus();
    }
  }

  componentDidUpdate() {
    if (
      this.customQuoteTableRef &&
      this.customQuoteTableRef.current &&
      this.props.isComponentActive
    ) {
      this.customQuoteTableRef.current.focus();
    }
  }

  _openQuoteTable = () => {
    if (!this.props.isSharedDocument) {
      this.props.toggleTabView(QUOTE_TABLE, this.props.quoteID);
      this.props.updateToolPaneData(false, null, QUOTE_TABLE);
    }
  };

  _getTableHeaders = () => {
    const {
      section: {
        data: { manage_column: manageColumns },
      },
    } = this.props;
    return manageColumns
      .filter(column => column.isChecked)
      .map(column => ({
        name: column.id,
        text: column.name,
      }));
  };

  _showManageColumns = () => {
    this.setState({ showColumnSettings: true });
  };

  _closeManageColumns = () => {
    this.setState({ showColumnSettings: false });
  };

  _handleColumnManage = columns => {
    const { section, handleBlur } = this.props;
    section.data.manage_column = columns;
    handleBlur(section);
  };

  _getBlankView = () => {
    const { handleBlur } = this.props;
    const headers = this._getTableHeaders().map(column => column.text);
    return (
      <Table
        className="quotetable"
        colResize={false}
        readOnly
        headers={headers}
        section={{ data: [] }}
        handleBlur={handleBlur}
      />
    );
  };

  _getNormalView = () => {
    const { handleBlur, metaData, rowData, columnDefs, currency } = this.props;
    const headers = this._getTableHeaders().map(column => column.text);
    const ungroupedData = getUngroupedData(
      metaData,
      rowData,
      this._getTableHeaders(),
      columnDefs,
      currency,
    );
    return (
      <Table
        className="quotetable"
        colResize={false}
        readOnly
        headers={headers}
        section={{ data: ungroupedData }}
        handleBlur={handleBlur}
      />
    );
  };

  _getDealtableGroupView = () => {
    const { rowData } = this.props;
    if (rowData && rowData.length === 0) return this._getBlankView();
    return this._getNormalView();
  };

  _getDealtableFooter = () => {
    const { currency, dealAmount, rowData } = this.props;
    if (rowData && rowData.length > 0) {
      return (
        <div className="dealtable-deal-discount">
          <div className="dealtable-deal-discountwrapper">
            <div className="row dealtable-deal-totalvalue">
              <div className="col-md-7">Quote Total:</div>
              <div className="col-md-5">
                {numberForamting(dealAmount, currency)}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="dealtable-deal-discount">
        <div className="dealtable-deal-discountwrapper">
          <div className="row dealtable-deal-totalvalue">
            <div className="col-md-7">Quote Total:</div>
            <div className="col-md-5">0</div>
          </div>
        </div>
      </div>
    );
  };

  _handleOnClick = event => {
    event.preventDefault();
    const { isComponentActive, isLocked, section } = this.props;
    if (!isLocked && !isComponentActive && section) {
      this.props.updateDocumentClickedComponentID(
        section.id,
        true,
        section.type,
      );
      if (this.props.createDocSectionRef) {
        this.props.createDocSectionRef(React.createRef());
      }
    }
  };

  _handleOnBlur = event => {
    event.preventDefault();
    if (this.props.isComponentActive) {
      this.props.updateDocumentClickedComponentID(null, true, null);
    }
  };

  render() {
    const { section, columnDefs, isDocumentLocked } = this.props;
    const { showColumnSettings } = this.state;

    const {
      data: { quote_id: quoteID, manage_column: manageColumns },
    } = section;

    let popUpSpace = null;
    if (showColumnSettings) {
      popUpSpace = (
        <Modal
          open={showColumnSettings}
          center
          onClose={this._closeManageColumns}>
          <ConfigureColumns
            columnDefs={columnDefs}
            manageColumns={manageColumns}
            closePopUp={this._closeManageColumns}
            handleColumnManage={this._handleColumnManage}
          />
        </Modal>
      );
    }
    if (quoteID) {
      return (
        <Fragment>
          <div
            ref={this.customQuoteTableRef}
            className={`customdealtable-component doc-dealtable-wrapper ${
              this.props.isComponentActive ? " active-customdealtable " : ""
            } ${
              this.props.isSharedDocument
                ? " shared-docoument-dealtable-wrapper "
                : ""
            }`}
            onClick={this._handleOnClick}
            onKeyPress={() => {}}
            onBlur={this._handleOnBlur}
            role="button"
            tabIndex={0}>
            <div className="custom-dealtable-header">
              <div className="custom-dealtable-titlewrapper custom-quote-titlewrapper">
                {!this.props.isSharedDocument && (
                  <div
                    className="custom-dealtable-headertitle custom-quote-headertitle"
                    onClick={() => this._openQuoteTable()}
                    onKeyDown={() => this._openQuoteTable()}
                    role="button"
                    tabIndex={0}>
                    Go to {DEAL_LABELS["deal-table-label"]}
                  </div>
                )}
                {!isDocumentLocked && (
                  <span
                    className="btn-icon custom-quote-btn-icon"
                    id="quotetable-columns-setting-btn"
                    onClick={this._showManageColumns}
                    onKeyDown={() => {}}
                    role="button"
                    tabIndex={0}>
                    <Tooltip
                      placement="top"
                      overlay="Configure columns"
                      align={{
                        offset: [0, 4],
                      }}>
                      <FontAwesomeIcon icon={["far", "cog"]} />
                    </Tooltip>
                  </span>
                )}
              </div>
              {popUpSpace}
            </div>
            <div className="dealtable-component component-table">
              {this._getDealtableGroupView()}
              {this._getDealtableFooter()}
            </div>
          </div>
        </Fragment>
      );
    }
    return <CustomQuoteTableWrapper {...this.props} />;
  }
}

const mapStateToProps = (state, props) => {
  const {
    data: { quote_id: quoteID },
  } = props.section;
  const {
    document: { status, pricelist, quoteTable },
    clickedActiveComponentId,
  } = state.DocumentStore;

  const {
    discount: discountObj = {},
    rowData: rowDataObj = {},
    metaData,
    columnDefs: columnDefObj = {},
  } = state.DealTableStore;

  // Pick out the required data from redux
  const rowData = rowDataObj[quoteID] || [];
  const discount = discountObj[quoteID] || {};
  const columnDefs = columnDefObj[quoteID] || [];
  const currency = pricelist ? CURRENCY_SYMBOL[pricelist.currency] : "$";
  const dealAmount = quoteTable.id === quoteID ? quoteTable.amount : 0;

  const isComponentActive = clickedActiveComponentId === props.section.id;

  return {
    quoteID,
    currency,
    discount,
    metaData,
    rowData,
    status,
    columnDefs,
    dealAmount,
    isComponentActive,
  };
};

const mapDispatchToProps = {
  updateDocumentClickedComponentID,
  updateToolPaneData,
  toggleTabView,
  updateDraggedSection,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomQuoteTable);



// WEBPACK FOOTER //
// ./src/components/DocumentItems/CustomQuoteTable.js